import React, { useState, useEffect } from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

export default function SelectEvent({ data, setSelectEvent, myEvent }) {
  const theme = useTheme();
  const [personName, setPersonName] = useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
    setSelectEvent(typeof value === "string" ? value.split(",") : value);
  };

  const setMyEvent = () => {
    //alert(JSON.stringify(myEvent));
    myEvent.map((item) => {
      let value = item.eventData.eventName;
      setPersonName(typeof value === "string" ? value.split(",") : value);
      setSelectEvent(typeof value === "string" ? value.split(",") : value);
    });
  };

  useEffect(() => {
    setMyEvent();
  }, [myEvent]);

  return (
    <div>
      <FormControl fullWidth margin="normal">
        <InputLabel id="demo-multiple-chip-label">กิจกรรม</InputLabel>
        <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          value={personName}
          onChange={handleChange}
          input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
          renderValue={(selected) => (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected.map((value) => (
                <Chip key={value} label={value} />
              ))}
            </Box>
          )}
          MenuProps={MenuProps}
        >
          {data.map((item, key) => (
            <MenuItem
              key={key}
              value={item.eventName}
              style={getStyles(item.eventName, personName, theme)}
            >
              {item.eventName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
